/** Copy / download one chat message as Markdown — a quiet icon pair under
 *  each question and answer. */
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { IconButton, Stack, Tooltip } from '@mui/material';

import { useSnackbar } from '@/components/Snackbar';
import { downloadText } from '@/utils/download';

export function MessageActions({
  markdown,
  filename,
  what,
}: {
  markdown: string;
  filename: string;
  /** "question" | "answer" — used in labels. */
  what: string;
}) {
  const snackbar = useSnackbar();
  const copy = () =>
    navigator.clipboard.writeText(markdown).then(
      () => snackbar.show(`The ${what} was copied as Markdown.`, 'success'),
      () => snackbar.show('Could not copy to the clipboard.', 'error'),
    );
  return (
    <Stack
      direction="row"
      spacing={0}
      sx={{ opacity: 0.55, transition: 'opacity 120ms', '&:hover, &:focus-within': { opacity: 1 } }}
    >
      <Tooltip title={`Copy the ${what} as Markdown`}>
        <IconButton size="small" aria-label={`Copy the ${what} as Markdown`} onClick={() => void copy()}>
          <ContentCopyIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
      <Tooltip title={`Download the ${what} as Markdown`}>
        <IconButton
          size="small"
          aria-label={`Download the ${what} as Markdown`}
          onClick={() => downloadText(markdown, filename, 'text/markdown')}
        >
          <FileDownloadOutlinedIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
